import { Box, Card, Typography, Container, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

const MainContent = styled(Box)(`
  height: 100%;
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`);

// interface RootState {
//   user: {
//     userDetails: {
//       userName?: string;
//       FirstName?: string;
//       LastName?: string;
//       EmailID?: string;
//       UserRole?: string;
//       accessToken?: string;
//       refreshToken?: string;
//       [key: string]: any;
//     };
//   };
// }

const Status404: React.FC = () => {
  // Retrieve user details from Redux state
  // const { userDetails } = useSelector((state: RootState) => state.user);
  // const { state: locationState, township, uuid } = useParams();

  // Check if userDetails exist
  // const hasUserDetails = Object.keys(userDetails).length > 0;

  // Determine the correct redirection URL based on user role
  // const redirectUrl = hasUserDetails
  //   ? userDetails.UserRole === 'Admin'
  //     ? `/${locationState}/${township}/${uuid}/bid-portal/Admin/home`
  //     : `/${locationState}/${township}/${uuid}/bid-portal/home`
  //   : `/${locationState}/${township}/${uuid}/login`;

  return (
    <>
      {/* <h2>Status - 404</h2> */}

      <MainContent>
        <Container maxWidth="md">
          <Container maxWidth="lg">
            <Card sx={{ textAlign: 'center', mt: 3, p: 4 }}>
              <Box textAlign="center">
                <img
                  alt="404"
                  height={180}
                  width="100%"
                  src="/static/images/status/404.svg"
                />
                <Typography variant="h2" sx={{ my: 2 }}>
                  The page you were looking for doesn't exist.
                </Typography>
              </Box>
              <Divider sx={{ my: 4 }} />
              {/* <Button href={redirectUrl} variant="outlined">
                {hasUserDetails ? 'Go to Home' : 'Go to Login'}
              </Button> */}
            </Card>
          </Container>
        </Container>
      </MainContent>
    </>
  );
};

export default Status404;
